import React from "react";
import { IconButton, IconButtonProps } from "@mui/material";
import Favorite from "@mui/icons-material/Favorite";
import FavoriteBorder from "@mui/icons-material/FavoriteBorder";
import * as S from "./styles";

/*
  To work this component is necessary create and controlled useState in props
  Example:
  const [isFavorite, setIsFavorite] = useState(false)

    <FavoriteButton
      isFavorite={isFavorite}
      onToggleFavorite={() => setIsFavorite(prev => !prev)}
    />
*/
interface IFavoriteButtonProps extends IconButtonProps {
	isFavorite: boolean;
	sizeIcon?: "default" | "small" | "medium" | "large" | "inherit";
	onToggleFavorite: () => void;
	notClickable?: boolean;
}

function FavoriteButton({
	isFavorite,
	sizeIcon = "medium",
	onToggleFavorite,
	notClickable = false,
	...props
}: IFavoriteButtonProps) {
	function handleToggleFavorite(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
		if (notClickable) {
			e.stopPropagation();
			onToggleFavorite();
		}
	}

	return (
		<S.Container>
			<IconButton
				aria-label="favorite"
				onClick={handleToggleFavorite}
				{...props}
				style={notClickable ? { cursor: "unset" } : { cursor: "pointer" }}
			>
				{isFavorite ? <Favorite fontSize={sizeIcon} /> : <FavoriteBorder fontSize={sizeIcon} />}
			</IconButton>
		</S.Container>
	);
}

export default FavoriteButton;
